import { gql } from "@apollo/client";

import { mylensesOrganizationsFragment } from "../fragments";
export const myLensesOrganizations = gql`
    query myLensesOrganizations($limit: Int!, $cursor: String!) {
        myLensesOrganizations(input: { limit: $limit, cursor: $cursor }) {
            ...MyLensesOrganizations
        }
    }
    ${mylensesOrganizationsFragment}
`;
